<template>
	<div class="page lottery-page">
		<van-nav-bar :title="lottery.name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>

		<div class="lottery-record">
			<div class="record-period">
				<van-image class="record-icon" src="/img/mine/head_logo.png">
					<template v-slot:loading>
						<van-loading type="spinner" />
					</template>
				</van-image>
				<span class="period-number">{{ lottery.now_expect }}</span>
				<div class="next-number">
					<van-count-down :time="time" @finish="check()" />
				</div>
			</div>
		</div>

		<div class="lottery-body">
			<div class="options-bar">
				<div class="game-options">
					<div class="sumValueTwoSides">
						<div class="option-card" :class="{ active: choose[v.type] }"
							v-for="(v, key) in lottery_peilv_list" :key="key" @click="choosePlay(v.type, v.name)">
							<div class="option-inner">
								<p class="option-name">
									{{ v.name=='big'?rose:v.name=='small'?lily:v.name=='one'?fireworks:balloon }}
								</p>
								<!-- <p class="option-odd">{{ v.proportion }}</p> -->
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Bottom bar -->
			<div class="bottom-bar">
				<div class="bar-main">
					<div class="bar-left">
						<div class="bar-item" @click="shopping = !shopping">
							<van-icon name="cart-o" class="cart-icon" />
						</div>
					</div>
					<div class="bar-mid">
						<span class="bar-text">{{ $t("reservation.available_balance") }}:</span>
						<span class="bar-num">{{ this.userInfo.money }}</span>
					</div>
					<div class="bar-right" @click="jiesuan()">
						{{ $t("reservation.submit") }}
					</div>
				</div>

				<div class="bar-slider" :class="{ active: shopping }">
					<div class="slider-item">
						<span class="slider-label">{{ $t("reservation.curr_choose") }}：</span>
						<div class="slider-value">{{ convertedShopchoose }}</div>
						<van-icon name="arrow-down" :class="{ up: !shopping, down: shopping }"
							@click="shopping = !shopping" />
					</div>
					<div class="slider-item">
						<span class="slider-label">{{ $t("reservation.per_price") }}</span>
						<van-field v-model="money" type="digit" :placeholder="$t('reservation.price_place')"
							class="slider-input" />
					</div>
				</div>
			</div>

			<!-- Settlement popup -->
			<van-popup v-model="jiesuanpage" get-container="body">
				<div class="settlement-modal">
					<ul class="settlement-list">
						<li v-for="(v, key) in formData" :key="key" class="settlement-item">
							<div class="item-main">
								<p class="item-name">
									{{ v.name=='big'?rose:v.name=='small'?lily:v.name=='one'?fireworks:balloon}}
								</p>
								<p class="item-detail">
									1{{ $t("reservation.note") }}X{{ money }}{{ $t("reservation.unit") }}={{ money }}{{ $t("reservation.ge") }}
								</p>
							</div>
							<van-icon @click="clearChooes(v.type)" name="close" />
						</li>
					</ul>
					<div class="settlement-actions">
						<van-button class="action-cancel" type="default"
							@click="allClear()">{{ $t("reservation.clear_order") }}</van-button>
						<van-button class="action-submit" type="default"
							@click="doSub">{{ $t("reservation.submit") }}</van-button>
					</div>
				</div>
			</van-popup>

			<!-- History popup -->
			<van-popup v-model="active" position="top" :style="{ height: '70%' }">
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<div class="history-wrap">
						<div class="history-header">
							<div class="col-left">{{ $t("reservation.num") }}</div>
							<div class="col-right">{{ $t("reservation.win_num") }}</div>
						</div>
						<div class="history-item" v-for="(v, key) in lottery_list" :key="key">
							<div class="col-left">{{ v.expect }}</div>
							<div class="col-right">
								<span class="ball">{{ v.opencode[0] }}</span>
								<span class="ball">{{ v.opencode[1] }}</span>
								<span class="ball" style="margin-right: 16px;">{{ v.opencode[2] }}</span>
								<span class="result-sum">{{ v.opencode[0] + v.opencode[1] + v.opencode[2] }}</span>
								<span
									class="result-tag">{{ isBigSum(v.opencode[0] + v.opencode[1] + v.opencode[2]) ? rose :lily }}</span>
								<span
									class="result-tag">{{ (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? balloon : fireworks }}</span>
							</div>
						</div>
					</div>
				</van-pull-refresh>
			</van-popup>
		</div>

		<!-- Game switch popup -->
		<van-popup v-model="showModel" position="right" :style="{ width: '70%', height:'100%' }">
			<div class="game-switch-list">
				<div class="switch-item" v-for="(i,index) in gameitemData" :key="index" @click="tabList(i.id,i.key)">
					<div class="switch-icon">
						<van-image width="48" height="48" :src="i.ico" />
					</div>
					<div class="switch-name">{{ i.name }}</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	var time;
	var count = 0;
	export default {
		data() {
			return {
				jiesuanpage: false,
				showModel: false,
				rose: '',
				lily: '',
				balloon: "",
				fireworks: "",
				choose: {
					big: false,
					small: false,
					one: false,
					two: false,
					"3": false,
					"4": false,
					"5": false,
					"6": false,
					"7": false,
					"8": false,
					"9": false,
					"10": false,
					"11": false,
					"12": false,
					"13": false,
					"14": false,
					"15": false,
					"16": false,
					"17": false,
					"18": false,
				},
				playgame: false,
				shopping: false,
				isLoading: false,
				play: {},
				lottery_peilv_list: {},
				lottery_list: {},
				active: false,
				userInfo: {},
				lottery: {},
				sum: 0,
				size: "",
				double: "",
				time: 0,
				shopchoose: this.$t("reservation.no_choose"),
				gameitem: "",
				formData: [],
				money: "",
				ids: 11,
				keys: 5,
				gameitemData: [],
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			isBigSum(sum) {
				return sum >= 11 && sum <= 18;
			},
			doSub() {
				if (this.money === "0") {
					this.$toast(this.$t("reservation.money_err"));
					return false;
				}
				if (this.formData.length === 0) {
					this.$toast(this.$t("reservation.choose_num"));
					return false;
				}
				if (this.money === "") {
					this.$toast(this.$t("reservation.price_place"));
					return false;
				}
				if (this.userInfo.money - this.money * this.formData.length < 0) {
					this.$toast(this.$t("reservation.balance_enough"));
					return false;
				}
				this.$http({
					method: "post",
					data: {
						item: this.gameitem,
						money: this.money,
						lid: this.lottery.id,
						mid: this.userInfo.id,
						expect: this.lottery.now_expect
					},
					url: "game_place_order",
				}).then((res) => {
					if (res.code === 200) {
						this.$toast(res.msg);
						this.allClear();
						this.getUserInfo();
					} else if (res.code === 401) {
						this.$toast(res.msg);
					}
				});
			},
			allClear() {
				for (var i = 0; i < this.formData.length; i++) this.choose[this.formData[i]["type"]] = false;
				this.formData.length = 0;
				this.money = "";
				this.shopchoose = this.$t("reservation.no_choose");
				this.gameitem = "";
				this.shopping = false;
				this.jiesuanpage = false;
			},
			jiesuan() {
				if (this.formData.length === 0) {
					this.$toast(this.$t("reservation.choose_num"));
					return false;
				}
				if (this.money === "") {
					this.$toast(this.$t("reservation.price_place"));
					return false;
				}
				this.jiesuanpage = !this.jiesuanpage;
			},
			clearChooes(type) {
				for (var i = 0; i < this.formData.length; i++) {
					if (type === this.formData[i]["type"]) {
						this.formData.splice(i, 1);
						this.choose[type] = false;
					}
				}
				if (this.formData.length >= 1) {
					this.shopchoose = this.formData.map(j => j["name"]).join(',');
					this.gameitem = this.formData.map(j => j["type"]).join(',');
				} else {
					this.shopchoose = this.$t("reservation.no_choose");
					this.gameitem = "";
					this.shopping = false;
				}
				if (this.formData.length === 0) this.jiesuanpage = false;
			},
			choosePlay(type, name) {
				if (this.choose[type]) {
					this.choose[type] = false;
					this.formData = this.formData.filter(f => f.type !== type);
				} else {
					this.formData.push({
						name,
						type
					});
					this.choose[type] = true;
				}
				if (this.formData.length === 1) this.shopping = true;
				if (this.formData.length >= 1) {
					this.shopchoose = this.formData.map(j => j["name"]).join(',');
					this.gameitem = this.formData.map(j => j["type"]).join(',');
				} else {
					this.shopchoose = this.$t("reservation.no_choose");
					this.gameitem = "";
					this.shopping = false;
				}
			},
			check() {
				if (!localStorage.getItem("token")) this.$router.push({
					path: "/Login"
				});
				else {
					time = window.setInterval(() => {
						setTimeout(() => {
							this.getUserInfo();
							this.getLotteryInfo();
							this.getLotteryList();
							count++;
							if (count > 5) {
								clearInterval(time);
								count = 0;
							}
						}, 0);
					}, 300);
				}
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.getLotteryList();
					this.isLoading = false;
				}, 200);
			},
			getUserInfo() {
				this.$http({
					method: "get",
					url: "user_info"
				}).then((res) => {
					if (res.code === 200) this.userInfo = res.data;
					else if (res.code === 401) this.$toast(res.msg);
				});
			},
			getLotteryPeilv() {
				this.$http({
					method: "get",
					data: {
						id: this.ids
					},
					url: "lottery_get_peilv"
				}).then((res) => {
					if (res.code === 200) this.lottery_peilv_list = res.data;
					else if (res.code === 401) this.$toast(res.msg);
				});
			},
			getLotteryList() {
				this.$http({
					method: "get",
					data: {
						key: this.keys
					},
					url: "lottery_get_one_list"
				}).then((res) => {
					if (res.code === 200) {
						this.lottery_list = res.data;
						this.getLotteryPeilv();
					} else if (res.code === 401) this.$toast(res.msg);
				});
			},
			getGameItem() {
				this.$http({
					method: 'get',
					url: 'lottery_list'
				}).then(res => {
					this.gameitemData = res.data;
				});
			},
			tabList(id, key) {
				this.ids = id;
				this.keys = key;
				this.showModel = false;
				this.getUserInfo();
				this.getGameItem();
				this.getLotteryInfo();
				this.getLotteryList();
			},
			getCookie(name) {
				name = name + '=';
				const decodedCookie = decodeURIComponent(document.cookie);
				const cookies = decodedCookie.split(';');
				for (let i = 0; i < cookies.length; i++) {
					let cookie = cookies[i];
					while (cookie.charAt(0) === ' ') cookie = cookie.substring(1);
					if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length);
				}
				return '';
			},
			getLotteryInfo() {
				this.$http({
					method: "get",
					data: {
						key: this.keys
					},
					url: "lottery_get_info"
				}).then((res) => {
					const lanng = localStorage.getItem("lang");
					if (res.code === 200) {
						const sel_id = this.getCookie('selid');
						if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
							this.$toast(this.$t("reservation.contact_admin"));
							this.$router.push({
								path: "/Home"
							});
							return false;
						}
						this.lottery = res.data;
						this.time = res.data.second * 1000;
						if (this.time / 1000 === 59) this.$toast(this.$t("reservation.prize_succ") + this.lottery
							.now_expect);
						this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
						if (sel_id == 1) {
							this.size = (this.sum >= 11 && this.sum <= 18) ? (lanng == 'zh' ? '玫瑰' : 'Roses') : (
								lanng == 'zh' ? '百合' : 'Lis');
							this.double = (this.sum % 2 === 0) ? (lanng == 'zh' ? '氣球' : 'Balloon') : (lanng ==
								'zh' ? '煙花' : 'Anneau');
						} else {
							this.size = (this.sum >= 11 && this.sum <= 18) ? (lanng == 'zh' ? '玫瑰' : 'Roses') : (
								lanng == 'zh' ? '百合' : 'Lis');
							this.double = (this.sum % 2 === 0) ? (lanng == 'zh' ? '氣球' : 'Balloon') : (lanng ==
								'zh' ? '煙花' : 'Anneau');
						}
					} else if (res.code === 401) this.$toast(res.msg);
				});
			},
		},
		created() {
			if (!localStorage.getItem("token")) this.$router.push({
				path: "/Login"
			});
			else {
				this.getUserInfo();
				this.getGameItem();
				this.getLotteryInfo();
				this.getLotteryList();
			}
			const lang = localStorage.getItem("lang");
			const r = lang == 'zh' ? '玫瑰' : 'Roses';
			const l = lang == 'zh' ? '百合' : 'Lis';
			const b = lang == 'zh' ? '氣球' : 'Balloon';
			const f = lang == 'zh' ? '煙花' : 'Anneau';
			this.rose = r;
			this.lily = l;
			this.balloon = b;
			this.fireworks = f;
		},
		computed: {
			convertedShopchoose() {
				const mapping = {
					big: this.rose,
					small: this.lily,
					one: this.fireworks,
					two: this.balloon
				};
				return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
			}
		},
		destroyed() {
			clearInterval(time);
		},
	};
</script>

<style lang="less" scoped>
	.lottery-page {
		display: flex;
		flex-direction: column;
		background: #f6f5f2;
		padding-bottom: 210px;
	}

	.nav-bar {
		background: linear-gradient(135deg, #7c6ff0, #db6ea9) !important;
	}

	/* Record section */
	.lottery-record {
		background: linear-gradient(135deg, #7c6ff0, #db6ea9);
		padding: 12px 20px;
	}

	.record-period {
		display: flex;
		align-items: center;
		gap: 16px;
	}

	.record-icon {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		overflow: hidden;
		flex-shrink: 0;
	}

	.period-number {
		flex: 1;
		font-size: 24px;
		font-weight: 700;
		color: #fff;
	}

	.van-count-down {
		color: #ffd700;
		font-size: 32px;
	}

	/* Options */
	.lottery-body {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.options-bar {
		flex: 1;
		display: flex;
		padding: 16px;
	}

	.game-options {
		flex: 1;
		overflow-y: auto;
	}

	.sumValueTwoSides {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
	}

	.option-card {
		width: calc(50% - 6px);
		background: rgba(255, 255, 255, .74);
		border-radius: var(--radius-md);
		box-shadow: var(--shadow-soft);
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		border: 1px solid rgba(255, 255, 255, .72);
		overflow: hidden;
		cursor: pointer;
		transition: all .2s ease;

		&.active {
			background: var(--gradient-primary);
			border-color: transparent;

			.option-name,
			.option-odd {
				color: #fff;
			}
		}

		&:active {
			transform: scale(.97);
		}
	}

	.option-inner {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 42px 16px;
		gap: 4px;
	}

	.option-name {
		font-size: 26px;
		font-weight: 600;
		color: var(--text);
	}

	.option-odd {
		font-size: 20px;
		color: var(--accent);
		font-weight: 700;
	}

	/* Bottom bar */
	.bottom-bar {
		position: fixed;
		left: 0;
		right: 0;
		bottom: 110px;
		z-index: 10;
	}

	.bar-main {
		display: flex;
		align-items: center;
		height: 88px;
		padding: 0 16px;
		background: rgba(255, 255, 255, .92);
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		border-top: 1px solid rgba(17, 24, 39, .06);
		box-shadow: 0 -4px 20px rgba(0, 0, 0, .06);
	}

	.bar-left {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.bar-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 12px;
		cursor: pointer;
	}

	.cart-icon {
		font-size: 36px;
		color: var(--primary);
	}

	.bar-mid {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 4px;
	}

	.bar-text {
		font-size: 24px;
		color: var(--muted);
	}

	.bar-num {
		font-size: 28px;
		font-weight: 700;
		color: var(--accent);
	}

	.bar-right {
		padding: 0 28px;
		height: 56px;
		line-height: 56px;
		margin-left: 12px;
		border-radius: 999px;
		background: var(--gradient-primary);
		color: #fff;
		font-size: 26px;
		font-weight: 600;
		cursor: pointer;
	}

	.bar-slider {
		position: absolute;
		bottom: 100%;
		left: 0;
		right: 0;
		padding: 16px;
		background: rgba(255, 255, 255, .95);
		backdrop-filter: blur(16px);
		-webkit-backdrop-filter: blur(16px);
		box-shadow: 0 -4px 20px rgba(0, 0, 0, .06);
		transition: transform .3s cubic-bezier(.22, .61, .36, 1);
		transform: translateY(100%);

		&.active {
			transform: translateY(0);
		}
	}

	.slider-item {
		display: flex;
		align-items: center;
		padding: 8px 0;
	}

	.slider-label {
		font-size: 26px;
		color: var(--text);
		flex-shrink: 0;
	}

	.slider-value {
		flex: 1;
		margin: 0 12px;
		overflow-x: auto;
		white-space: nowrap;
		color: var(--accent);
		font-size: 26px;
		font-weight: 500;
	}

	.slider-input {
		flex: 1;
		font-size: 26px;
		border-bottom: 1px solid var(--border);
	}

	/* Settlement modal */
	.settlement-modal {
		width: 600px;
		max-height: 60vh;
		display: flex;
		flex-direction: column;
		padding: 20px;
		background: rgba(255, 255, 255, .95);
		border-radius: var(--radius-lg);
	}

	.settlement-list {
		flex: 1;
		overflow-y: auto;
		list-style: none;
	}

	.settlement-item {
		display: flex;
		align-items: center;
		padding: 12px 0;
		gap: 8px;
	}

	.item-main {
		flex: 1;
	}

	.item-name {
		color: var(--accent);
		font-size: 28px;
		font-weight: 600;
		margin-bottom: 4px;
	}

	.item-detail {
		font-size: 22px;
		color: var(--hint);
	}

	.settlement-actions {
		display: flex;
		gap: 16px;
		margin-top: 20px;
	}

	.action-cancel,
	.action-submit {
		flex: 1;
		height: 72px;
		border-radius: 999px;
		font-size: 28px;
		font-weight: 600;
		border: none !important;
	}

	.action-cancel {
		background: #f3f4f6;
		color: var(--muted);
	}

	.action-submit {
		background: var(--gradient-primary);
		color: #fff;
	}

	/* History popup */
	.history-wrap {
		padding: 16px;
	}

	.history-header,
	.history-item {
		display: flex;
		align-items: center;
		padding: 12px 0;
	}

	.history-header {
		font-weight: 700;
		border-bottom: 1px solid var(--border);
		margin-bottom: 8px;
	}

	.col-left {
		width: 30%;
		font-size: 24px;
		color: var(--text);
	}

	.col-right {
		flex: 1;
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
	}

	.ball {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		background: linear-gradient(135deg, var(--primary), var(--accent));
		color: #fff;
		font-size: 14px;
		font-weight: 700;
	}

	.result-sum {
		font-weight: 700;
		font-size: 20px;
		color: var(--text);
	}

	.result-tag {
		display: inline-block;
		padding: 2px 10px;
		border-radius: 999px;
		background: linear-gradient(135deg, var(--primary), var(--accent));
		color: #fff;
		font-size: 12px;
		font-weight: 700;
	}

	/* Game switch */
	.game-switch-list {
		padding: 20px;
	}

	.switch-item {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 16px;
		margin-bottom: 12px;
		background: rgba(255, 255, 255, .74);
		border-radius: var(--radius-md);
		box-shadow: var(--shadow-soft);
		cursor: pointer;
		transition: transform .2s ease;

		&:active {
			transform: scale(.97);
		}
	}

	.switch-icon {
		width: 48px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fff;
		border-radius: 12px;
		overflow: hidden;
	}

	.switch-name {
		font-size: 26px;
		font-weight: 600;
		color: var(--text);
	}
</style>